






import { Component } from 'vue-property-decorator';
import { LelyTableColumnsConfig } from '@hn-work/frontend-vue-shared';
import { Getter } from 'vuex-class';
import { mixins } from 'vue-class-component';
import UsesFarmId from '@/mixins/UsesFarmId';
import Overview from '@/components/Overview.vue';
import FeedType from '@/core/interfaces/FeedType';
import VehicleType from '@/core/interfaces/VehicleType';

@Component({
    components: { Overview },
})
export default class FarmFeedTypesView extends mixins<UsesFarmId>(UsesFarmId) {
    @Getter('feedTypesByFarm')
    feedTypesByFarm!: (id: number) => FeedType[];

    @Getter('vehicleTypeById')
    vehicleTypeById!: (id: number) => VehicleType;

    get feedTypes(): FeedType[] {
        return this.feedTypesByFarm(Number(this.farmId));
    }

    get columns(): LelyTableColumnsConfig<FeedType> {
        return [
            {
                value: 'id',
                header: 'ID',
                shrink: true,
            },
            {
                header: 'Name',
                value: 'name',
            },
            {
                header: 'Vehicle type',
                value: feedType => this.vehicleTypeById(feedType.vehicle_type_id)?.name || '',
            },
        ];
    }
}

